import type {SyncIntegration} from '@cohort/merchants/apps';
import BrevoSyncConfigComponent from '@cohort/merchants/apps/brevo/sync/UserSyncConfigComponent';
import type {BrevoSyncStruct} from '@cohort/shared/apps/brevo/sync';
import {BrevoSyncSpec} from '@cohort/shared/apps/brevo/sync';

export const BrevoSyncIntegration: SyncIntegration<BrevoSyncStruct> = {
  spec: BrevoSyncSpec,
  syncConfigComponent: BrevoSyncConfigComponent,
};
